import {useQuery} from '@tanstack/react-query';
import {getChatbotAnswerList} from '@/api/help/chatbot';
import {AnswerListResponse} from '@/api/help/chatbot/type';

interface UseGetChatbotAnswerListProps {
  searchWord: string;
}

export const useGetChatbotAnswerList = ({
  searchWord,
}: UseGetChatbotAnswerListProps) => {
  return useQuery({
    queryKey: ['help', 'chatbot', 'answerList', searchWord],
    queryFn: () => getChatbotAnswerList(searchWord),
    select: (data: AnswerListResponse): string[] => {
      if ('answerList' in data) {
        return data.answerList;
      }
      return [];
    },
    enabled: !!searchWord,
  });
};
